import ArachnaApi from "./requests/arachna-api";
import Cookies from "js-cookie";
import { generateABBucket } from "../utils/generateAbbucket";
export default (config) => {
    const userAbBucket = Cookies.get("userABBucket") || generateABBucket();
    const request = ArachnaApi.getInstance().request;
    return request.post(`/logging/call/post?abBucket=${userAbBucket}`, Object.assign({}, config === null || config === void 0 ? void 0 : config.data));
};
